export default "__VITE_ASSET__AI539zs1__"